import * as React from 'react';
import { AmorgAdminPageProvider } from '../_contexts/AmorgAdminPageContext';
import type { AdminTabProps } from '../amorgAdmin/_components/AdminTab';
import styled from 'styled-components';
import { AdminTab } from '../amorgAdmin/_components/AdminTab';


type AmorgyPageWrapperProps = React.PropsWithChildren<{
    selectedTab:AdminTabProps['selectedTab'],
    subMenuContent?:React.ReactNode
}>;

export const AmorgyPageWrapper = (props:AmorgyPageWrapperProps) => 
{
    return (
        <AmorgAdminPageProvider>
            <Main data-layout="AmorgyPageWrapper_Main">
                <MenuRow data-layout="AmorgyPageWrapper_MenuRow">
                    <AdminTab selectedTab={props.selectedTab} />
                    {props.subMenuContent}
                </MenuRow>

                <ContentRow data-layout="AmorgyPageWrapper_ContentRow">
                    {props.children}
                </ContentRow>

            </Main>
        </AmorgAdminPageProvider>
    )    
};


const Main = styled.div`
    display:flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    margin: 0 auto;
    gap: 32px;
`;

const MenuRow = styled.div`
    width:90%;
    max-width: 1020px;
    margin: 16px auto 0 auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const ContentRow = styled.div``;
